/**
 * useRegisterTutorialActions — lets a component lend the tutorial its functions.
 *
 * A step sometimes has to change the draft: pre-fill the situation the user just
 * dropped, or undo an edge they drew to the wrong place. Those functions only
 * exist inside the editor's providers, which the tutorial provider sits above,
 * so the editor pushes them down instead.
 *
 * Registration is a ref write, not state, so lending a function costs no render.
 */

import { useEffect } from 'react';
import { useTutorial } from './TutorialContext';

export default function useRegisterTutorialActions(actions) {
    const { registerActions } = useTutorial();

    // The object literal a caller passes is new every render, so key the effect
    // on the functions themselves.
    const values = Object.values(actions || {});

    useEffect(() => {
        if (!registerActions) return undefined;
        return registerActions(actions);
    }, [registerActions, ...values]);
}
